<template>
  <div class="box" style="position: relative;">
    <div class="is-flex is-justify-content-space-between">
      <div class="mr-4" style="width: 50px;">
        <InputText :modelValue="quantity" @input="$emit('update:quantity', $event.target.value)" />
      </div>
      <div style="width: 100%;">
        <div class="is-flex is-justify-content-space-between">
          <div>
            <h3 class="title is-5">{{ direct.name }}</h3>
          </div>
          <div class="tag is-primary is-light">
            <div v-if="direct.date">
              {{new Date(direct.date).toDisplay()}}
            </div>
          </div>
        </div>
        <div>
          <AddressDisplay :value="direct" />
          <div v-if="!direct.city && !direct.zip && !direct.province && direct.address">
            <small class="has-text-grey is-abbr-like" :title="direct.address">{{direct.address}}</small>
          </div>
          <div v-if="direct.cf">
            <small class="has-text-grey is-abbr-like">Codice fiscale: {{direct.cf}}</small>
          </div>
          <div v-if="direct.vat">
            <small class="has-text-grey is-abbr-like">Partita IVA: {{direct.vat}}</small>
          </div>
          <div v-if="direct.sdi">
            <small class="has-text-grey is-abbr-like">SDI: {{direct.sdi}}</small>
          </div>
          <div v-if="direct.email">
            <small class="has-text-grey is-abbr-like">Email: {{direct.email}}</small>
          </div>
          <div class="mt-2">
            <strong>Prezzo: € {{customPrice || listPrice || '0.00'}}</strong>
            <div v-if="vat && vatTotal" class="has-text-grey mt-1 mb-1 is-size-7">
              IVA: {{ vat }}% | Totale ivato: € {{ vatTotal }}
            </div>
            <button class="button is-small is-info ml-2" @click="$emit('editPrice')" type="button">
              <font-awesome-icon icon="pen" /> Modifica
            </button>
          </div>
        </div>
      </div>
    </div>

    <button class="button is-danger is-small" @click="$emit('delete')" title="Elimina" style="position: absolute;right: 20px;bottom: 20px;">
      <span class="icon"><font-awesome-icon icon="trash-can" /></span>
    </button>
  </div>
</template>

<script>
import InputText from './InputText.vue';
import AddressDisplay from './AddressDisplay.vue';

export default {
  components: {
    InputText,
    AddressDisplay
  },

  props: ['direct', 'quantity', 'customPrice', 'listPrice', 'vat', 'vatTotal'],

  emits: ['delete', 'update:quantity', 'editPrice']
}
</script>